import { Classes, Position, Toaster } from "@blueprintjs/core";
import { AppToaster } from "./state";

let toaster: AppToaster | undefined;

if (typeof document !== "undefined") {
    createToaster();
}

function createToaster() {
    toaster = Toaster.create({
        className: Classes.DARK,
        position: Position.BOTTOM,
    });
}

export function getToaster() {
    if (toaster === undefined) {
        createToaster();
    }
    return toaster!;
}
